import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Tooltip, Link } from "@mui/material";
import RiskSlider from "./RiskSlider";
import RiskLabel from "./RiskLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function RiskScoreTable({ data }: any) {
  return (
    <TableContainer sx={{ borderRadius: "10px" }}>
      <Table size="small" aria-label="a dense table">
        <TableHead></TableHead>
        <TableBody>
          {data?.timber_risk_score !== null && (
            <TableRow sx={{ height: "80px" }}>
              <Tooltip
                title={
                  <React.Fragment>
                    "Comprehensive assessment of timber illegality associated with
                    specific countries. Source: Preferred by Nature Timber
                    Sourcing Hub. For more information, see the{" "}
                    <Link
                      href="/understand-risk"
                      target="_blank"
                      style={{ color: "#6db2b8" }}
                    >
                      Understanding Risk section
                    </Link>
                    .{" "}
                  </React.Fragment>
                }
                placement="top-start"
              >
                <TableCell>
                  Timber Sourcing Hub Risk Score
                  <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>
                </TableCell>
              </Tooltip>
              <TableCell
                width="220px"
                sx={{
                  textAlign: "center",
                  "&:hover": { cursor: "default" },
                }}
              >
                <RiskSlider
                  sliderType={"normal"}
                  data={data?.timber_risk_score}
                />
              </TableCell>
              <TableCell align="right">0 is most risky, 100 is least</TableCell>
            </TableRow>
          )}
          {data?.cpi_score !== null && (
            <TableRow sx={{ height: "80px" }}>
              <Tooltip
                placement="top-start"
                title={
                  <React.Fragment>
                    Measure of perceived government corruption as determined by a
                    combination of surveys and independent assessment. Updated
                    annually. Source: Transparency International For more
                    information, see the{" "}
                    <Link
                      href="/understand-risk"
                      target="_blank"
                      style={{ color: "#6db2b8" }}
                    >
                      Understanding Risk section
                    </Link>
                    .{" "}
                  </React.Fragment>
                }
              >
                <TableCell>
                  Corruption Perceptions Index (CPI) Score
                  <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>
                </TableCell>
              </Tooltip>
              <TableCell width="200px" sx={{ textAlign: "center" }}>
                <RiskSlider sliderType={"normal"} data={data.cpi_score} />
              </TableCell>
              <TableCell align="right">0 is most corrupt, 100 is least</TableCell>
            </TableRow>
          )}
          {data?.ipi_score !== null && (
            <TableRow sx={{ height: "80px" }}>
              <Tooltip
                title={
                  <React.Fragment>
                    Standardized measure of six measures for public integrity and
                    transparency. Updated annually. Source: CorruptionRisk.org.
                    For more information, see the{" "}
                    <Link
                      href="/understand-risk"
                      target="_blank"
                      style={{ color: "#6db2b8" }}
                    >
                      Understanding Risk section
                    </Link>
                    .{" "}
                  </React.Fragment>
                }
                placement="top-start"
              >
                <TableCell>
                  Index of Public Integrity (IPI) Score
                  <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>
                </TableCell>
              </Tooltip>
              <TableCell sx={{ textAlign: "center" }}>
                <RiskSlider sliderType={"ipi"} data={data.ipi_score} />
              </TableCell>
              <TableCell align="right">
                10 is most able to control corruption, 1 is least
              </TableCell>
            </TableRow>
          )}
          {data.forest_trends_idat_score !== null && (
            <TableRow sx={{ height: "80px" }}>
              <Tooltip
                title={
                  <React.Fragment>
                    This is the Forest Trends' IDAT (Illegal Deforestation Assessment Tool) score.{" "}
                    <Link
                      href="https://woodrisk.org/understanding-risk"
                      target="_blank"
                      style={{ color: "#6db2b8" }}
                    >
                      Understanding Risk section
                    </Link>
                    .{" "}
                  </React.Fragment>
                }
                placement="top-start"
              >
                <TableCell>
                  Forest Trends' IDAT Risk Score
                  <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>
                </TableCell>
              </Tooltip>
              <TableCell sx={{ textAlign: "center" }}>
                <RiskSlider sliderType={"idat"} data={data.forest_trends_idat_score} />
              </TableCell>
              <TableCell align="right">
                100 is higher risk, 0 is lower risk
              </TableCell>
            </TableRow>
          )}
          {data.eudr_country_benchmarking !== null && (
            <TableRow sx={{ height: "80px" }}>
              <Tooltip
                title={
                  <React.Fragment>
                    EUDR Country Benchmarking assessment indicating the risk level for this country under the EU Deforestation Regulation.{" "}
                    <Link
                      href="/understand-risk"
                      target="_blank"
                      style={{ color: "#6db2b8" }}
                    >
                      Understanding Risk section
                    </Link>
                    .{" "}
                  </React.Fragment>
                }
                placement="top-start"
              >
                <TableCell>
                  EUDR Country Benchmarking
                  <InfoOutlinedIcon fontSize={"small"}></InfoOutlinedIcon>
                </TableCell>
              </Tooltip>
              <TableCell
                width="220px"
                sx={{
                  textAlign: "center",
                  "&:hover": { cursor: "default" },
                }}
              >
                <RiskLabel value={data.eudr_country_benchmarking} />
              </TableCell>
              <TableCell align="right">Low, Standard, or High risk</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
